import { wwzrdsCatalogMenu } from '../catalog-menu/init-catalog-menu';

class MobileMenu {
	domElement;
	overlayElement;
	headerElement;
	toggleButton;
	isOpen;
	boundOnEsc;

	constructor(rootElement) {
		if (!rootElement) return;
		this.domElement = rootElement;
		this.overlayElement = this.domElement.querySelector('.catalog-menu__overlay');
		this.headerElement = document.querySelector('.header');
		this.toggleButton = document.querySelector('[data-menu]');
		this.isOpen = this.domElement.classList.contains('active');
		this.boundOnEsc = this.onEscPress.bind(this);
		this.init();
	}

	init = () => {
		// Toggle by top mobile menu button
		if (this.toggleButton) {
			this.toggleButton.addEventListener('click', (event) => {
				event.preventDefault();
				// Prevent other click handlers on the same element from running
				if (typeof event.stopImmediatePropagation === 'function') {
					event.stopImmediatePropagation();
				}
				// If desktop catalog menu is open, close it and do nothing else
				const catalogMenuElement = document.querySelector('.catalog-menu');
				const isCatalogOpen = catalogMenuElement && catalogMenuElement.classList.contains('active');
				if (isCatalogOpen) {
					if (typeof wwzrdsCatalogMenu !== 'undefined' && wwzrdsCatalogMenu && typeof wwzrdsCatalogMenu.close === 'function') {
						wwzrdsCatalogMenu.close();
					} else {
						// Fallback: close via DOM if instance is not available
						catalogMenuElement.classList.remove('active');
						document.body.classList.remove('overflow-hidden');
						if (this.headerElement) {
							this.headerElement.classList.remove('header--menu-open');
						}
					}
					return;
				}

				// If mobile search is open, close it first
				const mobileSearch = document.querySelector('.header__actions-search-mobile');
				const isSearchOpen = mobileSearch && mobileSearch.classList.contains('is-open');
				if (isSearchOpen) {
					mobileSearch.classList.remove('is-open');
					const input = mobileSearch.querySelector('input');
					if (input) {
						input.blur();
						input.value = '';
					}
					// Close search results if open
					const searchResults = mobileSearch.querySelector('.search-results');
					if (searchResults && searchResults.classList.contains('is-open')) {
						searchResults.classList.remove('is-open');
					}
				}

				// If mobile menu is open, close it; otherwise open it
				if (this.isOpen) {
					this.close();
				} else {
					this.open();
				}
			});
		}

		// Overlay to close
		if (this.overlayElement) {
			this.overlayElement.addEventListener('click', () => this.close());
		}
	};

	open = () => {
		if (this.isOpen) return;
		this.domElement.classList.add('active');
		document.body.classList.add('overflow-hidden');
		this.isOpen = true;
		document.addEventListener('keydown', this.boundOnEsc);
		if (this.headerElement) {
			this.headerElement.classList.add('header--menu-open');
		}
	};

	close = () => {
		if (!this.isOpen) return;
		document.body.classList.remove('overflow-hidden');
		this.domElement.classList.remove('active');
		this.isOpen = false;
		document.removeEventListener('keydown', this.boundOnEsc);
		if (this.headerElement) {
			this.headerElement.classList.remove('header--menu-open');
		}
	};

	toggle = () => {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	};

	onEscPress = (event) => {
		if (event.key === 'Escape') {
			this.close();
		}
	};
}

export { MobileMenu };


